// Angular
import {
    Component,
    Input,
    OnInit,
    AfterViewInit,
    Output,
    EventEmitter
} from "@angular/core";

@Component({
    selector: 'countdown',
    templateUrl: './countdown-widget.component.html',
    styleUrls: ['./countdown-widget.component.scss']
})

export class CountdownComponent implements AfterViewInit {
    @Input() millisecond: number;
    @Input() requestId: number;
    @Output() countDownFinishedEvent = new EventEmitter<number>();
    remainingTime: string = "00:00:00";
    isCountDownEventEmitted: boolean = false;
    IntervalCounter: any;
    constructor() {}

    ngAfterViewInit() {
     //   console.log("this.millisecond", this.millisecond);
        // this.msToTime();
      this.IntervalCounter =  setInterval(() => this.msToTime(this.millisecond), 1000);
    };

    pad(n) {
        let z = 2;
        return ('00' + n).slice(-z);
    };

    msToTime(s) {
        // let s = this.millisecond;
        // console.log("this.millisecond", this.millisecond);
        // console.log("this.millisecond > 1000", this.millisecond > 1000);
        if (s >= 1000) {
            var ms = s % 1000;
            s = (s - ms) / 1000;
            var secs = s % 60;
            s = (s - secs) / 60;
            var mins = s % 60;
            var hrs = (s - mins) / 60;
            this.remainingTime = this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs)
            // console.log("test");
            // console.log(this.millisecond)
            this.millisecond = this.millisecond - 1000;
            if (this.isCountDownEventEmitted) {
                this.isCountDownEventEmitted = false;
          //      console.log("set to false " + this.requestId);
            }

        } else {
            this.remainingTime = "00:00:00";
            if (!this.isCountDownEventEmitted) {
              //  console.log("Event Emmited id " + this.requestId);
                this.countDownFinishedEvent.emit(this.requestId);
                this.isCountDownEventEmitted = true;
            }
        }
    };


    ngOnDestroy() {
        //console.log("ng OnDestroy")
        if (this.IntervalCounter) {
          clearInterval(this.IntervalCounter);
        }
      }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/countdownWidget/countdown-widget.component.ts